var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBus = function SvgBus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 8h10a1 1 0 0 1 1 1v1H10V9a1 1 0 0 1 1-1zm-1 3v7h12v-7Zm-2 0h-.5c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5H8v6a1 1 0 0 0 1 1v1.17c0 .46.37.83.83.83h1.34c.46 0 .83-.37.83-.83V24h8v1.17c0 .46.37.83.83.83h1.34c.46 0 .83-.37.83-.83V24a1 1 0 0 0 1-1v-6h.33c.92 0 1.67-.75 1.67-1.67v-2.66c0-.92-.75-1.67-1.67-1.67H24V9a3 3 0 0 0-3-3H11a3 3 0 0 0-3 3Zm14 8H10v3h12z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBus);
export default ForwardRef;